// extracted by mini-css-extract-plugin
module.exports = {"modal":"AddInsurance_modal__UCrfd"};